import { render, staticRenderFns } from "./Rankingeneral.vue?vue&type=template&id=68a25282"
import script from "./Rankingeneral.vue?vue&type=script&lang=js"
export * from "./Rankingeneral.vue?vue&type=script&lang=js"
import style0 from "./Rankingeneral.vue?vue&type=style&index=0&id=68a25282&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports